import { useEffect, useRef, useState } from 'react';
import { CssBaseline } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';

import { IUserFromStorage } from '../../../Interfaces/IUser';
import { IInitialState } from '../../../Shared/data/FormReducer';

import './styles/navMobile.css';
import './styles/pageTransition.css';


interface IProps {
  selectedPage: number;
  setSelectedPage: (state: number) => void;
  state: IInitialState;
  routes: React.ReactElement | null;
}

const navItems = [
  {
    label: 'Inicio',
    path: '/',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    label: 'Productos',
    path: '/mis-productos',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
        <line x1="12" y1="22.08" x2="12" y2="12" />
      </svg>
    ),
  },
  {
    label: 'Perfil',
    path: '/perfil',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
];

const NavigationSideBarMobile = ({ selectedPage, setSelectedPage, state, routes } : IProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeIdx, setActiveIdx] = useState<number>(0);
  const [transitionClass, setTransitionClass] = useState('page-enter');
  const prevPathRef = useRef(location.pathname);

  const userStr = localStorage.getItem('user');
  const user: IUserFromStorage | null = userStr ? JSON.parse(userStr) : null;

  useEffect(() => {
    const idx = navItems.findIndex(item => item.path === location.pathname);
    if (idx !== -1) setActiveIdx(idx);
  }, [location.pathname]);

  useEffect(() => {
    if (prevPathRef.current !== location.pathname) {
      setTransitionClass('page-exit');
      const timer = setTimeout(() => {
        setTransitionClass('page-enter');
        prevPathRef.current = location.pathname;
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  const handleNav = (path: string, idx: number) => {
    setActiveIdx(idx);
    setSelectedPage(idx);
    navigate(path);
  };

  const showNav =
    localStorage.getItem('user') &&
    user?.respondio &&
    location.pathname !== '/despuesTest' &&
    location.pathname !== '/uploadVideo';

  return (
    <>
      <Box sx={{ display: 'flex', width: '100%', minHeight: '85%', overflowX: 'hidden' }}>
        <CssBaseline />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 1,
            pb: '5rem',
            minWidth: 0,
            overflowX: 'hidden',
            boxSizing: 'border-box',
          }}
        >
          <div className={`page-transition ${transitionClass}`}>
            {routes}
          </div>
        </Box>
      </Box>

      {showNav && (
        <nav className="gnav">
          <div className="gnav-inner">
            {navItems.map((item, i) => (
              <button
                key={item.label}
                className={`gnav-item ${activeIdx === i ? 'gnav-item--active' : ''}`}
                onClick={() => handleNav(item.path, i)}
              >
                <span className="gnav-icon">{item.icon}</span>
                <span className="gnav-label">{item.label}</span>
              </button>
            ))}
          </div>
        </nav>
      )}
    </>
  );
};

export default NavigationSideBarMobile;
